import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  discussion: Boundaries["removeDiscussion"]["request"],
) {
  const index = state.findIndex(
    (req) => req.discussion.uuid === discussion.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { discussion, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { discussion, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  discussion: Boundaries["removeDiscussion"]["success"],
) {
  const index = state.findIndex(
    (req) => req.discussion.uuid === discussion.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { discussion, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { discussion, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  discussion: Boundaries["removeDiscussion"]["failure"],
) {
  const index = state.findIndex(
    (req) => req.discussion.uuid === discussion.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { discussion, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { discussion, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeDiscussionRequested]: handleRequest,
    [events.removeDiscussionSucceeded]: handleSuccess,
    [events.removeDiscussionFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
